<template>
  <div name="xpage-search-results" class="search-page-search-results">
    <SearchPageSearchResultsHeader :sticky="true" />
    <div
      name="xpage-search-results-data"
      class="search-page-search-results-data"
      v-auto-animate="{ duration: 100, ...$animate }"
    >
      <SearchPageSearchResultsTable
        v-show="
          searchResults &&
          searchResults.length > 0 &&
          !isLoading &&
          searchPageStore.searchPageState.layout !== 'boxes'
        "
        :results="searchResults"
        :freezeHeaderRow="searchPageStore.searchPageState.layout === 'table'"
        :showHeaders="false"
      />
      <div
        :class="['x' + searchPageStore.searchPageState.layout]"
        v-if="
          searchResults.length > 0 &&
          !isLoading &&
          searchPageStore.searchPageState.layout === 'boxes'
        "
        v-auto-animate="{ duration: 100, ...$animate }"
      >
        <a
          v-for="result in searchResults"
          :key="result.id"
          class="xrow"
          :href="getResultUrl(result)"
          @click.prevent="handleSearchPageResultCardClick(result)"
        >
          <SearchPageSearchResult :result="result" :pageName="pageName" />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";
import SearchPageSearchResult from "@/components/v2/search-page/SearchPageSearchResult.vue";
import SearchPageSearchResultsTable from "@/components/v2/search-page/SearchPageSearchResultsTable.vue";
import SearchPageSearchResultsHeader from "@/components/v2/search-page/SearchPageSearchResultsHeader.vue";

const searchPageStore = useSearchPageStore();

const props = defineProps({
  pageName: {
    type: String,
    default: "",
  },
});

const searchResults = ref<
  CertificationSearchResultModel[] | DisbursementSearchResultModel[]
>([]);

const isLoading = computed<boolean>(
  () => searchPageStore.searchPageState.loading
);

function handleSearchPageResultCardClick(
  result: CertificationSearchResultModel | DisbursementSearchResultModel
) {
  searchPageStore.handleSearchResultClick(result, props.pageName);
}


function getResultUrl(result: CertificationSearchResultModel | DisbursementSearchResultModel) {
  const page = props.pageName;
  const id = searchPageStore.getRouteIdentifier(page,result);
  return `/${page}/${id}`;
}

watch(
  () => searchPageStore.searchPageState.searchResults.data,
  (newValue) => {
    searchResults.value = newValue;
  }
);
</script>

<style scoped>
.xpage-search-results {
  width: 100%;
  max-width: calc(100% - 19px);
}

div.search-page-search-results-title,
div.xpage-search-results-title {
  display: block;
  line-height: 44px;
  font-family: Montserrat, arial, sans-serif;
  font-size: 19px;
  font-weight: 800;
  border-bottom: 1px solid rgb(183, 183, 183);
  margin: 0 0 15px 0;
}

div.search-page-search-results-data,
.xpage-search-results-data {
  margin-top: 0;
}
.xpage-search-results-content {
  display: flex;
  flex-wrap: wrap;
}

div.xboxes {
  display: flex;
  flex-wrap: wrap;
}

div.xboxes a.xrow {
  height: fit-content;
  width: 48%;
  border-radius: 6px 6px 6px 6px;
  border-top: 6px solid #48a842;
}

@media screen and (min-width: 1650px) {
  div.xboxes a.xrow {
    width: 31.33%;
  }
}

@media screen and (max-width: 620px) {
  div.xboxes a.xrow {
    width: 100%;
  }
}

@media screen and (max-width: 900px) {
  div.xboxes {
    gap: 2%;
  }
}
</style>
